import { baseUrl } from "../../common/config";
import { http } from "../../common/helpers/index";

export const updateProfileService = (data) => {
  return http.put(`${baseUrl}/api/participant`, data);
};

export const getSmsNotificationSetting = (profileId) => {
  return http.get(`${baseUrl}/api/sms/settings/${profileId}`);
};

export const updateSmsNotificationSetting = (data) => {
  return http.post(`${baseUrl}/api/sms/settings`, data);
};

export const getVaultFiles = ({ queryParams }) =>
  http.get(`${baseUrl}/api/vault/participant?${queryParams}`);

export const saveFolder = ({ isPrivate, parentId, name }) =>
  http.post(`${baseUrl}/api/vault/participant/folder`, {
    isPrivate,
    parentId,
    name,
  });

export const deleteFolder = ({ parentId, paramaterId }) =>
  http.delete(
    `${baseUrl}/api/vault/participant/folder/${parentId}?participantProfileId=${paramaterId}`
  );

export const saveFile = ({ formData }) =>
  http.post(`${baseUrl}/api/vault/participant/file`, formData);

export const deleteFile = ({ parentId, paramaterId }) =>
  http.delete(
    `${baseUrl}/api/vault/participant/file/${parentId}?participantProfileId=${paramaterId}`
  );

export const downloadFile = ({ paramaterId, fileId }) =>
  `${baseUrl}/api/vault/participant/file/${fileId}?participantProfileId=${paramaterId}`;
